import script from "./TareasView.vue?vue&type=script&setup=true&lang=js"
export * from "./TareasView.vue?vue&type=script&setup=true&lang=js"

import "./TareasView.vue?vue&type=style&index=0&id=88662e96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88662e96"]])

export default __exports__